import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { nmvTrackerAPI } from "../api/analyticsAPI";
import { APPROVED_USER_STATUS } from "../utils/constants";
import { useAuth } from "./AuthContext";

const NotificationContext = createContext(undefined);

export function NotificationProvider({ children }) {
  const { user } = useAuth();
  const { data: gmvPendingStatus } = useQuery({
    queryKey: ["gmvPendingStatus", user?.data?.id],
    queryFn: async () => {
      const token =
        localStorage.getItem("authToken") ||
        sessionStorage.getItem("authToken");
      if (!token) throw new Error("No token");

      return nmvTrackerAPI.getAllTimePendingGmvOverview();
    },
    enabled: user?.data?.status === APPROVED_USER_STATUS && !!user?.data?.id,
    refetchInterval: 1000 * 60 * 30, // 10 minutes
  });

  return (
    <NotificationContext.Provider value={{ gmvPendingStatus }}>
      {children}
    </NotificationContext.Provider>
  );
}

export const useNotifications = () => useContext(NotificationContext);
